export default __webpack_public_path__ + "static/media/out.d3b56bc8.svg";